import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios, { type AxiosRequestConfig } from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";

const axiosInstance = axios.create();
useAxiosAuthentication(axiosInstance);
const getAll = async (lookupPath: string, config?: AxiosRequestConfig) => {
  const url = `${import.meta.env.VITE_API_BASE_URL}${lookupPath}`;
  let response = null;

  try {
    response = await axiosInstance.get<string>(url, {
      ...config,
      headers: {
        ...config?.headers,
        ...DEFAULT_HEADERS,
        "api-key": import.meta.env.VITE_TENANT_API_KEY
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};

export default { getAll };
